export default __webpack_public_path__ + "static/media/mons7.7b974595.jpg";